import React from "react";
import { useIsMobile } from "@/hooks/useDisplay";

import * as styles from "./WelcomeOfferBanner.module.scss";

const WelcomeOfferBanner = () => {
  const isMobile = useIsMobile();

  return (
    <img
      className={styles.banner}
      src={
        isMobile
          ? "/images/welcome-offer-mobile.png"
          : "/images/welcome-offer-desktop.png"
      }
      alt="Welcome offer: 100% deposit match up to $250 in Bonus Cash. 1x turnover requirement. Eligible customers only. T&Cs apply."
    />
  );
};

export { WelcomeOfferBanner };
